// Type definitions for the SearchInvoices query response
// This matches the structure returned by the Hasura function cred_search_invoices

export interface SearchInvoiceCreditor {
    id: string | null;
    name: string | null;
    number: number | null;
}

export interface SearchInvoiceRealestate {
    id: string;
    name: string;
    number: string;
    zip: string | null;
    city: string | null;
    consolidation: boolean;
}

export interface SearchInvoiceUser {
    id: string;
    name1: string;
    name2: string | null;
}

export interface SearchInvoiceUnit {
    id: string | null;
    name: string | null;
    number: number | null;
    houseid: string | null;
}

export interface SearchInvoiceOrder {
    id: string | null;
    number: number | null;
}

export interface SearchInvoiceIncident {
    id: string | null;
    number: number | null;
}

export interface SearchInvoicePaymentInfo {
    iban: string;
    type: string;
    reference: string;
}

export interface SearchInvoiceCreditorInfo {
    uid: string | null;
    zip: string | null;
    city: string | null;
    name: string | null;
    street: string | null;
    country: string | null;
    housenumber: string | null;
}

export interface SearchInvoiceInfo {
    vatdate: string | null;
    vatrate: number;
    conditions: {
        discountRates?: any[];
        discountrate?: any[];
        ZahlungsfristTage?: number;
        paymentdeadline?: number | null;
    };
}

export interface SearchInvoice {
    id: string;
    type: number;
    number: number;
    date: string;
    duedate: string | null;
    paiddate: string | null;
    state: number;
    origin: number;
    invoicenumber: string | null;
    amount: number | null;
    creditor: SearchInvoiceCreditor | null;
    realestate: SearchInvoiceRealestate | null;
    assigned_user: SearchInvoiceUser | null;
    unit: SearchInvoiceUnit | null;
    order: SearchInvoiceOrder | null;
    incident: SearchInvoiceIncident | null;
    paymentinfo: SearchInvoicePaymentInfo | null;
    creditorinfo: SearchInvoiceCreditorInfo | null;
    invoiceinfo: SearchInvoiceInfo | null;
    rejectedcomment: string | null;
    fileid: string | null;
}

// Type guard to validate the structure
export function isSearchInvoice(obj: any): obj is SearchInvoice {
    return (
        obj &&
        typeof obj === "object" &&
        "id" in obj &&
        "number" in obj &&
        "state" in obj &&
        "type" in obj
    );
}

// Helper to safely parse the JSONB response
export function parseSearchInvoices(invoices: any): SearchInvoice[] {
    if (!Array.isArray(invoices)) {
        console.warn("SearchInvoices invoices is not an array:", invoices);
        return [];
    }

    return invoices.filter(isSearchInvoice);
}
